import React, { useState, useEffect } from 'react';
import {useAuth} from "../../auth/AuthProvider";
import { Spinner } from 'react-bootstrap';
import {getMachineErrorsArchive} from "../../../lib/api/getMachineErrorsArchive";
import {IconButton} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {MachineErrorsModal} from "./MachineErrorsModal";

export const MachineErrors_Archive = ({uniqueId}) => {
    const [errorCount, setErrorCount] = useState(0);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const {token} = useAuth();

    useEffect(() => {
        getMachineErrorsArchive(token, uniqueId).then(data => {
            setLoading(false);
            if (data && data.errors) {
                setErrors(data.errors);
                setErrorCount(data.errors.length);
            } else {
                setErrors(null);
                // setErrorCount(0);
            }
        }).catch(error => {
            console.log(error);
        });

    }, [token, uniqueId]);

    const handleShowModal = () => {
        if (errorCount > 0) {
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <MachineErrorsModal
                show={showModal}
                onClose={handleCloseModal}
                uniqueId={uniqueId}
                errors={errors}
            />

            <div className="d-flex align-items-center justify-content-center">
                {loading ? (
                    <Spinner animation="border" size="sm" />
                ) : errorCount > 0 ? (
                    <div className="d-flex align-items-center">
                        <span className="me-2" style={{color: 'red', fontWeight: 'bold'}}>
                            {errorCount}
                        </span>
                        <IconButton
                            size="small"
                            onClick={handleShowModal}
                            style={{color: 'red'}}
                        >
                            <ErrorOutlineIcon />
                        </IconButton>
                    </div>
                ) : (
                    <span style={{color: 'green'}}>0</span>
                )}
            </div>
        </>
    );
};
